// extracted by mini-css-extract-plugin
export var modal = "_ss-0";
export var table = "_ss-1";